console.log('heaer/index.js jQuery status', window.$);

var showEtcMobile = 'btn-icon-right btn-icon-chevron-down';

var headerTheme = $('header').data('headerTheme');

$(document).ready(function () {
    if (window.mobileTrigger) {
        $('#showEtcs').addClass(showEtcMobile);
    } else {
        $('#showEtcs').removeClass(showEtcMobile);
    }

    $('[name="mobile-sitelang"]').val(location.pathname);

    if ($('[data-theme]')) {
        $(document).scroll(function () {
            const headerHeight = $('header').height();
            let currentSection = null;

            $('[data-theme]').each(function () {
                const rect = $(this)[0].getBoundingClientRect();
                const theme = $(this).data('theme');

                if (rect.top <= headerHeight && rect.bottom > headerHeight) {
                    if (currentSection !== theme) {
                        currentSection = theme;
                        $('header').attr('class', theme)
                    }
                }
            });
        });

    } else {
        $(document).scroll(function () {
            $('header').toggleClass('scrolled', $(document).scrollTop() > 10);
            $('header').toggleClass(headerTheme, $(document).scrollTop() < 10);
        })
    }
})

$(window).resize(function () {
    etcsBtnTransform('#showEtcs');
})

function etcsBtnTransform(btn) {
    const trigger = $('#headerMore').hasClass('d-none');
    const sitelang = $.cookie('sitelang');
    const goBack = {
        '': 'Go back',
        'de': 'Zurück',
        'it': 'Indietro',
        'fr': 'Retourner'
    };
    const showAll = {
        '': 'Show all',
        'de': 'Alle anzeigen',
        'it': 'Mostra tutto',
        'fr': 'Afficher tout'
    };
    const hide_lang = {
        '': 'hide',
        'de': 'weniger anzeigen',
        'it': 'mostra meno',
        'fr': 'Montrer moins'
    }

    if (window.mobileTrigger) {
        if (trigger) {
            $(btn).text(showAll[sitelang]).addClass('btn-icon-chevron-down')
            $(btn).removeClass('btn-icon-chevron-up');
        }
        else {
            $(btn).text(hide_lang[sitelang]).addClass('btn-icon-chevron-up')
            $(btn).removeClass('btn-icon-chevron-down')
        }
    } else {
        const iconClass = 'btn-icon-left btn-icon-arrow-l';

        trigger ? $(btn).text(showAll[sitelang]).removeClass(iconClass)
            : $(btn).text(goBack[sitelang]).addClass(iconClass);
    }

    $('#headerMore').toggleClass('d-none', !trigger);
    $('#headerEtc').toggleClass('d-none', trigger);
    $('#Etcs').toggleClass('active', !trigger)
}

$('#showEtcs').click(function () {
    etcsBtnTransform('#showEtcs');
})

$('[data-lang]').click(function (e) {
    $.cookie('sitelang', $(this).attr('data-lang'), {
        path: '/', secure: true
    });
})

$('[name="mobile-sitelang"]').change(function () {
    let compare = {
        '/de': 'de',
        '/it': 'it',
        '/fr': 'fr',
    }
    selectlang = '';
    Object.keys(compare).forEach(key => {
        keyTest = new RegExp(key)

        if (keyTest.test($(this).val())) {
            selectlang += compare[key];
        } else selectlang += '';

        $.cookie('sitelang', selectlang, {
            path: '/', secure: true
        })
    })
    location.href = $(this).val();
})

$('.hamburger').click(function () {
    const trigger = $(this).hasClass('ham_active');
    $(this).toggleClass('ham_active', !trigger)
    $('header').toggleClass('active', !trigger)
    $(document.body).toggleClass('overflow-hidden', !trigger)
})

document.addEventListener("DOMContentLoaded", function () {
    const tooltips = document.querySelectorAll('.mytooltip');

    tooltips.forEach(tooltip => {
        const tooltipButton = tooltip.querySelector(".btn-tooltip");
        const tooltipContent = tooltip.querySelector(".mytooltip__content");
        let hideTooltipTimeout;

        tooltipButton.addEventListener("mouseenter", function () {
            clearTimeout(hideTooltipTimeout);
            tooltipContent.classList.add('active');
        });

        tooltipButton.addEventListener("mouseleave", function (event) {
            hideTooltipTimeout = setTimeout(function () {
                if (!tooltipContent.contains(event.relatedTarget)) {
                    tooltipContent.classList.remove('active');
                }
            }, 300);
        });

        tooltipContent.addEventListener("mouseenter", function () {
            clearTimeout(hideTooltipTimeout);
        });

        tooltipContent.addEventListener("mouseleave", function () {
            tooltipContent.classList.remove('active');
        });
    })
});

if (mobileTrigger) {

    $('header .active').removeClass('active');
    $('[data-target="#bitcoinSubmenu"],#bitcoinSubmenu').removeClass('active');

    $('.header__section_mobile').click(function (e) {
        e.preventDefault();

        $(this).toggleClass('active', $(this).hasClass('active') == false)

        const toggleMenu = $(this).parent().find('.header__submenu');

        $(this).attr('aria-expanded', $(this).hasClass('active') == false ? 'false' : 'true');
        toggleMenu.toggleClass('active', $(this).hasClass('active') == true)
    })

    $(document).click(function (e) {
        const target = $(e.target).is('[data-menu-parent]') ? $(e.target) : $(e.target).closest('[data-menu-parent]');
        $(target).addClass('active')

        $($(target).attr('data-target')).addClass('active');
    })

    $('[data-back]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        let target = $(this).attr('data-back');

        $(`[data-target='${target}'], ${target}`).removeClass('active');
    })
} else {
    function showHeaderMenu(e) {
        const target = $(e.target).is('[data-menu-parent]') ? $(e.target) : $(e.target).closest('[data-menu-parent]');
        const others = $(target).parent().find('[data-menu-parent]');

        $(others).each(function () {
            const target = $(this).attr('data-target');
            $(target).removeClass('active');
            $(this).removeClass('active');
        })

        $(target).addClass('active')
        $($(target).attr('data-target')).addClass('active');

        if (e.target.dataset.target == '#prodLink') {
            $('[data-target="#bitcoinSubmenu"]').addClass('active');
            $('#bitcoinSubmenu').addClass('active');
        }
    }

    $('[data-menu-parent]').hover(function (e) {
        e.stopPropagation();

        $('header .active').removeClass('active');

        showHeaderMenu(e);

        $('header').mouseleave(function () {
            $('header .active').removeClass('active');
        })

    })

    $('.header__section, .preheader__button').hover(function (e) {
        e.stopPropagation();
        $('header .active').removeClass('active');
        showHeaderMenu(e);
    })
}
